import Vue from 'vue';
import VueMeta from 'vue-meta';
import VTooltip from 'v-tooltip';
import vuescroll from 'vuescroll';
import { initialize as initializeSdk, Localization, TrackError, utils } from '@easygenerator/fragment-sdk';
import { FragmentsServiceFactory } from '@easygenerator/client-sdk.fragments';
import { FragmentsLoaderProvider, ModuleName } from '@easygenerator/client-sdk.common';
import App from '@/App.vue';
import Config from './config';
import SentryService from './sentry';
import { LANG, getTooltipDefaultOptions } from './types/constants';
import { EgCoverUploader } from './components';
import store from './store/index';
import router from './router';
import highlight from './filters/highlight';

Vue.config.productionTip = false;
let instance: Vue;

const fragmentName = 'learner-dashboard';

async function initialize() {
  const config = Config.getInstance();
  await config.initialize();

  FragmentsServiceFactory.initialize();
  await SentryService.initialize(router);

  utils.HttpWrapper.signInRedirectUrl = '#/login';
  utils.HttpWrapper.unauthorizedHandler = () => store.commit('app/RESET_TOKEN_LEARN');

  const translationManager = utils.TranslationManager.getInstance();

  await Promise.all([
    translationManager.initialize({ path: './localization/lang', supportedLangs: Object.values(LANG) }),
    store.dispatch('app/authorize')
  ]);

  initializeSdk({
    localize: translationManager.localize,
    initializePermissions: false
  });

  const UiKit = await FragmentsLoaderProvider.fragmentsLoader.loadModule(ModuleName.uiKit);
  Vue.use(UiKit);

  const logger = utils.Logger.getInstance();

  Vue.use(Localization);
  Vue.use(TrackError, { trackError: logger.trackError });
  Vue.use(vuescroll);
  Vue.use(VTooltip, getTooltipDefaultOptions());
  Vue.use(VueMeta, {
    refreshOnceOnNavigation: true
  });
  Vue.filter('highlight', highlight);
  Vue.component('EgCoverUploader', EgCoverUploader);
}

function render(element: Element) {
  document.body.classList.add(fragmentName);
  instance = new Vue({
    store,
    router,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    render: (h: any) => h(App),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    renderError(h: any, err: any) {
      return h('pre', { style: { color: 'red' } }, err.stack);
    }
  });

  instance.$mount(element);
}

function destroy() {
  document.body.classList.remove(fragmentName);
  if (instance) {
    instance.$destroy();
  }
}

export { destroy, initialize, render };
